import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@iconify/react';
import { LoadingButton } from '@mui/lab';
import { Grid, Dialog, Button, DialogContent } from '@mui/material';
import emailOutline from '@iconify-icons/eva/email-outline';

const MBDocumentsModal = props => {
  const {
    open,
    setModal,
    presignedURL,
    selectedVariables,
    setEmailVariables,
    sendingEmail,
    showEmailButton
  } = props;
  const ref = useRef(null);
  const refBottomNav = useRef(null);
  const [height, setHeight] = useState(0);
  const [bottomNavHeight, setBottomNavHeight] = useState(0);

  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
    setBottomNavHeight(refBottomNav?.current?.clientHeight);
  });

  return (
    <Dialog
      ref={ref}
      open={open}
      onClose={() => setModal(false)}
      maxWidth="lg"
      fullWidth={true}
      PaperProps={{
        style: { borderRadius: 0, height: '100vh' }
      }}
    >
      <DialogContent
        style={{
          padding: 5,
          overflow: 'hidden',
          marginTop: 0,
          display: 'block',
          height: '100%'
        }}
      >
        <iframe
          src={presignedURL}
          width="100%"
          height={height - bottomNavHeight}
          id="divPDF"
          style={{ overflow: 'hidden' }}
        />
      </DialogContent>
      <div
        style={{
          width: '100%',
          padding: '10px',
          display: 'flex',
          background: '#fafafa',
          justifyContent: 'flex-end'
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent="flex-end"
          ref={refBottomNav}
        >
          {/* unable to print waiverqueen pdfs */}
          {/* {showPrintButton && (
            <Grid item>
              <Button color="primary" variant="contained" onClick={handlePrint}>
                {' '}
                <Icon
                  icon={printerOutline}
                  color="white"
                  style={{ marginRight: '5px' }}
                />
                Print
              </Button>
            </Grid>
          )} */}
          {showEmailButton && (
            <Grid item>
              <LoadingButton
                loading={sendingEmail}
                color="primary"
                variant="contained"
                onClick={() => setEmailVariables(selectedVariables)}
              >
                <Icon
                  icon={emailOutline}
                  color="white"
                  style={{ marginRight: '5px' }}
                />{' '}
                Email
              </LoadingButton>
            </Grid>
          )}
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setModal(!open);
              }}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
};

export default MBDocumentsModal;
